import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { OperatingStatus } from '@/enum';
import { namespace } from 'vuex-class';
var User = namespace('user');
var signBusinessTypeEnum = {
  OVERSEAS_WAREHOUSE: 0,
  TRANSSHIPMENT_DELIVERY: 1,
  TAIL_TRANSPORT: 2,
  TARIFF_COLLECTION: 3
};

var AddEditShopModal = function (_super) {
  __extends(AddEditShopModal, _super);

  function AddEditShopModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.saveLoading = false;
    _this.formData = _this.initFormData();
    _this.formDataRule = {
      account_code: [{
        required: true,
        message: _this.t('请选择绑定主体'),
        trigger: 'change'
      }],
      shop_name: [{
        required: true,
        message: _this.t('请输入店铺名称'),
        trigger: 'blur'
      }, {
        min: 1,
        max: 50,
        message: _this.t('限制1~50字符'),
        trigger: 'blur'
      }]
    };
    return _this;
  }

  AddEditShopModal.prototype.onDataChange = function (data) {
    this.formData = Object.keys(data || {}).length ? this.$util.deepCopy(data) : this.initFormData();
  };

  AddEditShopModal.prototype.onVisibleChange = function (value) {
    if (!value) {
      var formDataRef = this.$refs.formDataRef;
      this.formData = this.initFormData();
      formDataRef && formDataRef.resetFields();
    }
  };

  Object.defineProperty(AddEditShopModal.prototype, "title", {
    get: function get() {
      return this.mode === OperatingStatus.edit ? this.t('编辑店铺') : this.t('新增店铺');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditShopModal.prototype, "isEdit", {
    get: function get() {
      return this.mode === OperatingStatus.edit;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditShopModal.prototype, "availableBodyList", {
    get: function get() {
      var _this = this;

      return this.bodyList.filter(function (b) {
        return b.sign_body_status === _this.$enum.mine.SignBodyStatusEnum.ENABLED;
      });
    },
    enumerable: false,
    configurable: true
  });

  AddEditShopModal.prototype.initFormData = function () {
    return {
      account_code: undefined,
      shop_name: ''
    };
  };

  AddEditShopModal.prototype.handleOk = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var payload, api, code;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              payload = this.mode === OperatingStatus.edit ? {
                id: this.formData.id,
                shop_name: this.formData.shop_name
              } : {
                account_code: this.formData.account_code,
                customer_code: this.customerInfo.customer_code,
                shop_name: this.formData.shop_name,
                sign_business_type: signBusinessTypeEnum.OVERSEAS_WAREHOUSE
              };
              this.saveLoading = true;
              _a.label = 1;

            case 1:
              _a.trys.push([1,, 3, 4]);

              api = this.mode === OperatingStatus.edit ? this.$api.shopManage.edit : this.$api.shopManage.add;
              return [4, api(payload)];

            case 2:
              code = _a.sent().code;

              if (code === 0) {
                this.$message.success(this.t('操作成功'));
                this.visible = false;
                this.$emit('success');
              }

              return [3, 4];

            case 3:
              this.saveLoading = false;
              return [7];

            case 4:
              return [2];
          }
        });
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": OperatingStatus.add
  })], AddEditShopModal.prototype, "mode", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], AddEditShopModal.prototype, "data", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], AddEditShopModal.prototype, "bodyList", void 0);

  __decorate([User.State('customerInfo')], AddEditShopModal.prototype, "customerInfo", void 0);

  __decorate([Watch('data')], AddEditShopModal.prototype, "onDataChange", null);

  __decorate([Watch('visible')], AddEditShopModal.prototype, "onVisibleChange", null);

  AddEditShopModal = __decorate([Component], AddEditShopModal);
  return AddEditShopModal;
}(Vue);

export default AddEditShopModal;